(function () {
  function init(root) {
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-event-quiz-step]'));
    var progress = root.querySelector('[data-event-quiz-progress]');
    var progressBar = root.querySelector('[data-event-quiz-progress-bar]');
    var backBtn = root.querySelector('[data-event-quiz-back]');
    var answers = {};
    var history = [];

    var collections = {
      eventPickupPacks: root.dataset.collectionEventPickupPacks || '',
      eventPickupBundles: root.dataset.collectionEventPickupBundles || '',
      onlinePacks: root.dataset.collectionOnlinePacks || '',
      onlineBundles: root.dataset.collectionOnlineBundles || ''
    };

    function setProgress(currentStep) {
      if (!progressBar) return;
      if (currentStep === 'not-at-event') {
        progressBar.style.width = '0%';
        return;
      }
      var idx = history.length;
      var pct = Math.min(100, Math.round((idx / steps.length) * 100));
      progressBar.style.width = pct + '%';
    }

    function showStep(name) {
      steps.forEach(function (step) {
        step.classList.toggle('is-active', step.dataset.eventQuizStep === name);
      });
      applyConditionalVisibility(name);
      if (backBtn) backBtn.hidden = history.length === 0;
      setProgress(name);
    }

    function applyConditionalVisibility(stepName) {
      if (stepName !== 'fulfillment') return;
      var atEvent = answers['at-event'];
      var step = steps.find(function (s) { return s.dataset.eventQuizStep === 'fulfillment'; });
      if (!step) return;
      step.querySelectorAll('[data-requires-event]').forEach(function (btn) {
        var required = btn.dataset.requiresEvent;
        btn.hidden = required && required !== atEvent;
      });
    }

    function resolveCollection() {
      var atEvent = answers['at-event'];
      var role = answers.role;
      var fulfillment = answers.fulfillment;
      var isPickup = atEvent === 'yes' && fulfillment === 'pickup';

      if (isPickup && role === 'joining') return collections.eventPickupPacks;
      if (isPickup && role === 'existing') return collections.eventPickupBundles;
      if (role === 'joining') return collections.onlinePacks;
      if (role === 'existing') return collections.onlineBundles;
      return '';
    }

    function finish() {
      var handle = resolveCollection();
      if (!handle) return;
      root.classList.add('is-finishing');
      window.location.href = '/collections/' + encodeURIComponent(handle);
    }

    function handleAnswer(e) {
      var btn = e.target.closest('[data-event-quiz-answer]');
      if (!btn || btn.hidden) return;
      var question = btn.dataset.question;
      var value = btn.dataset.value;
      if (!question || !value) return;

      answers[question] = value;
      history.push(question);

      var nextStep = getNextStep(question, value);
      if (nextStep) {
        showStep(nextStep);
      } else {
        finish();
      }
    }

    function getNextStep(currentQuestion, value) {
      if (currentQuestion === 'at-event' && value === 'no') return 'not-at-event';
      if (currentQuestion === 'at-event') return 'role';
      if (currentQuestion === 'role') return 'fulfillment';
      return null;
    }

    function goBack() {
      if (history.length === 0) return;
      var last = history.pop();
      delete answers[last];
      showStep(last);
    }

    function reset() {
      answers = {};
      history.length = 0;
      root.classList.remove('is-finishing');
      steps.forEach(function (step) {
        step.querySelectorAll('[data-requires-event]').forEach(function (btn) {
          btn.hidden = false;
        });
      });
      showStep('at-event');
    }

    root.addEventListener('click', handleAnswer);
    if (backBtn) backBtn.addEventListener('click', goBack);

    root.__eventQuizReset = reset;
    showStep('at-event');
  }

  function boot() {
    document.querySelectorAll('[data-event-quiz]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-event-quiz]').forEach(function (root) {
      if (typeof root.__eventQuizReset === 'function') root.__eventQuizReset();
    });
  });
})();
